$().ready(function() {
  var bannerElement = document.getElementById("global-banner");
  if (bannerElement) {
    globalComponentRendered(bannerElement)
    bannerElement.onclick = globalComponentClicked
  }
});

function globalComponentRendered(bannerElement) {
  if (window.analytics) {
	  window.analytics.track("Banner Displayed", analyticsData())
  }
}

function globalComponentClicked() {
	if (window.analytics) {
		window.analytics.track("Banner Clicked", analyticsData())
	}
}

function analyticsData() {
  var bannerData = $('#global-banner').data('analytics')
  var tgaPageData = (new TgAnalytics).pageData

  return {
    ...bannerData,
    ...tgaPageData
  }
}



// WEBPACK FOOTER //
// ./app/components/global/banner_component.js